module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style3/message-alert-style3.component.scss
// module id = ./src/app/features/message-alert/message-alert-style3/message-alert-style3.component.scss
// module chunks = main